var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.637,
    height: 27.363,
    viewBox: "0 0 27.637 27.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-216.551 -732.818)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(231.824 747.818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.363V10.818c0-1.7,2.782-3.091,6.182-3.091s6.182,1.391,6.182,3.091v1.545ZM3.09,3.091a3.091,3.091,0,1,1,3.091,3.09A3.091,3.091,0,0,1,3.09,3.091Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.551 747.818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.363V10.818c0-1.7,2.782-3.091,6.182-3.091s6.182,1.391,6.182,3.091v1.545ZM3.09,3.091a3.091,3.091,0,1,1,3.091,3.09A3.091,3.091,0,0,1,3.09,3.091Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.188 732.818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.363V10.818c0-1.7,2.782-3.091,6.182-3.091s6.182,1.391,6.182,3.091v1.545ZM3.09,3.091a3.091,3.091,0,1,1,3.091,3.09A3.091,3.091,0,0,1,3.09,3.091Z",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar03);
export default __webpack_public_path__ + "static/media/avatar_03.3b559c402880ae1585d30045fe6ce990.svg";
export { ForwardRef as ReactComponent };